import { FC, SVGProps } from 'react';

const BoxArrowInRight: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.33333 5.33334C8.96514 5.33334 8.66667 5.63181 8.66667 6V8.66667C8.66667 9.03486 8.36819 9.33334 8 9.33334C7.63181 9.33334 7.33333 9.03486 7.33333 8.66667V6C7.33333 4.89543 8.22876 4 9.33333 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H9.33333C8.22876 20 7.33333 19.1046 7.33333 18V15.3333C7.33333 14.9651 7.63181 14.6667 8 14.6667C8.36819 14.6667 8.66667 14.9651 8.66667 15.3333V18C8.66667 18.3682 8.96514 18.6667 9.33333 18.6667H20C20.3682 18.6667 20.6667 18.3682 20.6667 18V6C20.6667 5.63181 20.3682 5.33334 20 5.33334H9.33333ZM16.6679 12C16.6679 12.1771 16.5974 12.3469 16.472 12.472L12.472 16.472C12.3034 16.6406 12.0576 16.7065 11.8272 16.6448C11.5969 16.583 11.417 16.4031 11.3552 16.1728C11.2935 15.9424 11.3594 15.6966 11.528 15.528L14.3907 12.6667H2.66667C2.29848 12.6667 2 12.3682 2 12C2 11.6318 2.29848 11.3333 2.66667 11.3333H14.3907L11.528 8.472C11.3594 8.30338 11.2935 8.05759 11.3552 7.82724C11.417 7.59689 11.5969 7.41696 11.8272 7.35524C12.0576 7.29352 12.3034 7.35938 12.472 7.528L16.472 11.528C16.5974 11.6531 16.6679 11.8229 16.6679 12Z"
      fill="currentColor"
    />
  </svg>
);

export default BoxArrowInRight;
